import * as types from "../../actions/actionTypes";
import { PETTY_CASH_PRINT_INFO_MODAL_DATA } from "../../actions/actionTypes";

const initialData = {
  data: []
};

const initialState = {
  loading: false,
  detail: {},
  detailError: "",
  detailFetched: false,

  filteredDetail: initialData,
  filteredLoading: false,
  filteredFetched: false,

  listLoading: false,
  list: [],
  listError: "",
  fetchedList: false,

  changeStateProcessing: false,
  error: "",

  selected: {},
  meta: {},
  select_archive: {},
  newState: "",
  last_info: {},
  itemsLoading: false,
  itemsError: false,
  itemsObject: {},

  printInfoProcessing: false,
  printInfoModalStatus: false,
  printInfoModalData: {}
};

const PettyCashierPettyCash = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASH_DETAIL_REQUEST:
      return {
        ...state,
        detail: {},
        loading: true,
        detailError: ""
      };
    case types.PETTY_CASH_DETAIL_SUCCESS:
      return {
        ...state,
        detail: action.payLoad,
        loading: false
      };
    case types.PETTY_CASH_DETAIL_FAILURE:
      return { ...state, loading: false, detailError: action.error };

    case types.PETTY_CASH_DETAIL_FILTER_REQUEST:
      return {
        ...state,
        filteredLoading: true,
        detailError: ""
      };
    case types.PETTY_CASH_DETAIL_FILTER_SUCCESS:
      return {
        ...state,
        filteredDetail: action.payLoad,
        filteredFetched: true,
        filteredLoading: false
      };
    case types.PETTY_CASH_DETAIL_FILTER_FAILURE:
      return { ...state, filteredLoading: false, detailError: action.error };

    case types.PETTY_CASH_EMPTY_DETAIL_FILTER:
      return { ...state, filteredDetail: initialData, filteredFetched: false };

    case types.PETTY_CASH_DETAIL_CLEAR:
      return { ...state, detail: {} };

    case types.PETTY_CASHIER_GET_PETTY_CASH_REQUEST:
      return {
        ...state,
        selected: {},
        loading: true,
        error: ""
      };
    case types.PETTY_CASHIER_GET_PETTY_CASH_SUCCESS:
      return {
        ...state,
        selected: action.payLoad,
        loading: false
      };
    case types.PETTY_CASHIER_GET_PETTY_CASH_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.PETTY_CASHIER_GET_PETTY_CASH_ITEMS_REQUEST:
      return {
        ...state,
        itemsObject: {},
        itemsObjectLoading: true,
        itemsObjectError: ""
      };
    case types.PETTY_CASHIER_GET_PETTY_CASH_ITEMS_SUCCESS:
      return {
        ...state,
        itemsObject: action.payLoad,
        itemsObjectLoading: false
      };
    case types.PETTY_CASHIER_GET_PETTY_CASH_ITEMS_FAILURE:
      return {
        ...state,
        itemsObjectLoading: false,
        itemsObjectError: action.error
      };

    case types.PETTY_CASH_STORE_REQUEST:
      return { ...state, loading: true };
    case types.PETTY_CASH_STORE_SUCCESS:
      return { ...state, loading: false, select_archive: {}, last_info: {} };
    case types.PETTY_CASH_STORE_FAILURE:
      return { ...state, loading: false };

    case types.PETTY_CASH_UPDATE_REQUEST:
      return { ...state, loading: true };
    case types.PETTY_CASH_UPDATE_SUCCESS:
      return { ...state, loading: false, select_archive: {}, last_info: {} };
    case types.PETTY_CASH_UPDATE_FAILURE:
      return { ...state, loading: false };

    case types.PETTY_CASHIER_GET_LIST_PETTY_CASH_REQUEST:
      return {
        ...state,
        listLoading: true,
        list: [],
        meta: {},
        listError: "",
        fetchedList: false
      };
    case types.PETTY_CASHIER_GET_LIST_PETTY_CASH_SUCCESS:
      const { data, ...meta } = action.payLoad;
      return {
        ...state,
        list: data,
        meta: meta,
        fetchedList: true,
        listLoading: false
      };
    case types.PETTY_CASHIER_GET_LIST_PETTY_CASH_FAILURE:
      return { ...state, listLoading: false, listError: action.error };

    case types.PETTY_CASH_SELECT_ARCHIVE_UPDATE:
      return { ...state, select_archive: action.data };
    case types.PETTY_CASH_SAVE_LAST_INFO:
      return { ...state, last_info: action.data };

    case types.PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_REQUEST:
      return { ...state, changeStateProcessing: true };
    case types.PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_SUCCESS:
      return {
        ...state,
        selected: action.payLoad,
        changeStateProcessing: false
      };
    case types.PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_FAILURE:
      return { ...state, changeStateProcessing: false };

    case types.REMOVE_PETTY_CASH_REQUEST:
      return { ...state, loading: true };
    case types.REMOVE_PETTY_CASH_SUCCESS:
      return { ...state, loading: false };
    case types.REMOVE_PETTY_CASH_FAILURE:
      return { ...state, loading: false };

    case types.PETTY_CASH_PRINT_INFO_MODAL_DATA:
      return {
        ...state,
        printInfoModalData: action.data,
        printInfoModalStatus: true
      };
    case types.PETTY_CASH_PRINT_INFO_CLOSE_MODAL:
      return { ...state, printInfoModalData: {}, printInfoModalStatus: false };
    case types.PETTY_CASH_UPDATE_INFO_REQUEST:
      return { ...state, printInfoProcessing: true };
    case types.PETTY_CASH_UPDATE_INFO_SUCCESS:
      return {
        ...state,
        printInfoProcessing: false,
        selected: { ...state.selected, ...action.data },
        printInfoModalStatus: false,
        printInfoModalData: {}
      };
    case types.PETTY_CASH_UPDATE_INFO_FAILURE:
      return { ...state, printInfoProcessing: false };

    default:
      return state;
  }
};

export default PettyCashierPettyCash;
